import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import {
  GetQUestionParams,
  TikZType,
  manualReplaceQuestion,
  generatedQuestionObj,
  generatedQuestionTestType,
  searchQuestionRes,
  subTopicQuestionDetailNew,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';

declare var update: any;

@Component({
  selector: 'app-manual-replace-dialog',
  templateUrl: './manual-replace-dialog.component.html',
  styleUrls: ['./manual-replace-dialog.component.scss'],
})
export class ManualReplaceDialogComponent implements OnInit {
  notifier: NotifierService;
  generatedAutoReplaceQuestions: generatedQuestionObj[] = [];
  images: any = null;
  selectedQuestion: any = {};
  choices: string[] = ['A', 'B', 'C', 'D', 'E', 'F'];
  isDataLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public questionData: manualReplaceQuestion,
    private globalApiService: GlobalApiService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.getAutoReplaceQuestions();
  }

  getAutoReplaceQuestions() {
    this.isDataLoading = true;
    const questionTestTypeInfo: generatedQuestionTestType =
      this.questionData.questionInfo.questionDetails.questionTestTypes[0];
    const questionInfo: subTopicQuestionDetailNew =
      this.questionData.questionInfo;
    console.log(this.questionData.ignoredQuestionCategories);
    const params: GetQUestionParams = {
      topicId: questionTestTypeInfo.topicId,
      subTopicId: questionInfo.subTopicId,
      difficultyLevel: questionInfo.difficultLevel,
      pageNo: 1,
      questionType: questionInfo.questionType,
      // tags: questionInfo.questionDetails.question.tags.toString(),
      tags: '',
      canRepeatQuestions: this.questionData.canRepeatQuestions,
    };
    params.ignoredQuestionCategories =
      this.questionData.ignoredQuestionCategories.length > 0
        ? this.questionData.ignoredQuestionCategories.join(
            '&ignoredQuestionCategories='
          )
        : '';
    // console.log(params.ignoredQuestionCategories);
    this.globalApiService.getQuestionsWithParams(params).subscribe({
      next: (res: searchQuestionRes) => {
        // TODO: Filter duplicate questions based on subTopicId (WIP)
        // let filteredQuestions: generatedQuestionObj[] = [];
        this.questionData.questionIds?.forEach(
          (questionId, questionIdIndex) => {
            res.questions.forEach((question, questionIndex) => {
              if (question.question.questionId === questionId) {
                res.questions.splice(questionIndex, 1);
              }
            });
          }
        );
        // console.log(filteredQuestions);
        // filteredQuestions = res.questions.filter((question) => question.questionTestTypes[0].subTopicId =  )
        this.generatedAutoReplaceQuestions = res.questions;
        this.makeImages();
        this.loadTikz();
        console.log(this.generatedAutoReplaceQuestions);
        this.isDataLoading = false;
      },
      error: (err) => {
        this.isDataLoading = false;
        console.log(err);
        this.notifier.notify('error', 'Unable to fetch questions');
      },
    });
  }

  getImages(listOfImages: string[]) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          this.images = { ...this.images, ...data };
        }
        console.log(this.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  makeImages() {
    let listOfImages: string[] = [];
    this.generatedAutoReplaceQuestions.forEach(
      (generatedQuestionsObj, generatedQuestionsObjIndex) => {
        // ** For choices (MCQ's)
        generatedQuestionsObj.choices?.forEach((choice, choiceIndex) => {
          // ** For choices (Explanations)
          choice.explanation?.forEach((explanation, explanationIndex) => {
            if (explanation.type === 'Images') {
              explanation['images'] = JSON.parse(explanation.data);
              listOfImages.push(...(explanation['images'] as string[]));
            }
          });
          // ** For choices Options
          choice.optionValue.forEach((choiceData, choiceDataIndex) => {
            if (choiceData.type === 'Images') {
              choiceData['images'] = JSON.parse(choiceData.data);
              listOfImages.push(...(choiceData['images'] as string[]));
            }
          });
        });
        // ** For answers (Freetext) - Explanaions
        generatedQuestionsObj.answers?.explanation.forEach(
          (freetextExplanation, freeTextExplanationIndex) => {
            if (freetextExplanation.type === 'Images') {
              freetextExplanation['images'] = JSON.parse(
                freetextExplanation.data
              );
              listOfImages.push(...(freetextExplanation['images'] as string[]));
            }
          }
        );
        // ** For questions
        generatedQuestionsObj.question.questionData.forEach(
          (questionDataObj, questionDataObjIndex) => {
            if (questionDataObj.type === 'Images') {
              questionDataObj['images'] = JSON.parse(questionDataObj.data);
              listOfImages.push(...(questionDataObj['images'] as string[]));
            }
          }
        );
      }
    );
    this.getImages(listOfImages);
  }

  getPossibilities(questionsObjIndex: number): string {
    let returnPossibilities: string | undefined = '';
    returnPossibilities =
      this.generatedAutoReplaceQuestions[
        questionsObjIndex
      ].answers?.posibilities.join(' ');
    return `Possibilities: ${returnPossibilities as string}`;
  }

  selectQuestionToReplace(questionsObjIndex: number): any {
    this.selectedQuestion =
      this.generatedAutoReplaceQuestions[questionsObjIndex];
    console.log(this.selectedQuestion);
    return this.generatedAutoReplaceQuestions[questionsObjIndex];
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
    }, 500);
  }

  loadTikz() {
    const totaltikZ: TikZType[] = [];
    this.generatedAutoReplaceQuestions.forEach(
      (generatedQuestionMain, generatedQuestionMainIndex) => {
        // ** tikz for questions
        generatedQuestionMain.question.questionData.forEach(
          (questionInfo, questionInfoIndex) => {
            if (questionInfo.type === 'TikZ') {
              totaltikZ.push({
                id:
                  'autoReplaceQuestion-' +
                  generatedQuestionMainIndex +
                  '-' +
                  questionInfoIndex,
                data: questionInfo.data,
              });
            }
          }
        );
        // ** tikz for freetext answer - explanations
        generatedQuestionMain.answers?.explanation.forEach(
          (freetextExplanation, freetextExplanationIndex) => {
            if (freetextExplanation.type === 'TikZ') {
              totaltikZ.push({
                id:
                  'autoReplaceFreetextExplanation-' +
                  generatedQuestionMainIndex +
                  '-' +
                  freetextExplanationIndex,
                data: freetextExplanation.data,
              });
            }
          }
        );
        // ** tikz for choices (options and explanations)
        generatedQuestionMain.choices?.forEach((mcqChoice, mcqChoiceIndex) => {
          // ** tikz for explanations in choices
          mcqChoice.explanation?.forEach(
            (mcqChoiceExplanation, mcqChoiceExplanationIndex) => {
              if (mcqChoiceExplanation.type === 'TikZ') {
                totaltikZ.push({
                  id:
                    'autoReplaceChoiceExplanation-' +
                    generatedQuestionMainIndex +
                    '-' +
                    mcqChoiceIndex +
                    '-' +
                    mcqChoiceExplanationIndex,
                  data: mcqChoiceExplanation.data,
                });
              }
            }
          );
          mcqChoice.optionValue.forEach(
            (mcqChoiceOption, mcqChoiceOptionIndex) => {
              if (mcqChoiceOption.type === 'TikZ') {
                totaltikZ.push({
                  id:
                    'autoReplaceChoiceOption-' +
                    generatedQuestionMainIndex +
                    '-' +
                    mcqChoiceIndex +
                    '-' +
                    mcqChoiceOptionIndex,
                  data: mcqChoiceOption.data,
                });
              }
            }
          );
        });
      }
    );
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  getChoiceOption(choiceObjIndex: number) {
    return this.choices[choiceObjIndex];
  }
}
